"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactNumbers;
(function (ContactNumbers) {
    ContactNumbers[ContactNumbers["INTERIOR_ACCESS_NUMBER"] = 8008410607] = "INTERIOR_ACCESS_NUMBER";
    ContactNumbers[ContactNumbers["UNDER_CONTRACT_WINNER_NUMBER"] = 8006325045] = "UNDER_CONTRACT_WINNER_NUMBER";
    ContactNumbers[ContactNumbers["PENDING_WINNER_NUMBER"] = 8007936107] = "PENDING_WINNER_NUMBER";
    ContactNumbers[ContactNumbers["BIDDER_SUPPORT_NUMBER"] = 8002802832] = "BIDDER_SUPPORT_NUMBER";
    ContactNumbers[ContactNumbers["OFFER_SUPPORT_NUMBER"] = 8007936107] = "OFFER_SUPPORT_NUMBER";
    ContactNumbers[ContactNumbers["ONLINE_BUYER_EXPERIENCE"] = 8007936107] = "ONLINE_BUYER_EXPERIENCE";
    ContactNumbers[ContactNumbers["FCL_ONLINE_CONTACT_NUMBER"] = 8008519558] = "FCL_ONLINE_CONTACT_NUMBER";
    ContactNumbers[ContactNumbers["SMART_SALE_CONCIERGE"] = 8553223050] = "SMART_SALE_CONCIERGE";
})(ContactNumbers || (ContactNumbers = {}));
exports.default = ContactNumbers;
//# sourceMappingURL=contactNumbers.js.map